import portrait from "@/assets/lizy-portrait.jpg";
import { sobreMi } from "@/data/content";
import PageHeader from "@/components/site/PageHeader";
import { Reveal } from "@/components/site/Reveal";
import BookCTA from "@/components/site/BookCTA";

export default function SobreMi() {
  return (
    <div data-testid="sobre-mi-page">
      <PageHeader
        overline="Sobre mí"
        titleLines={["Lizy", "Rodríguez"]}
        intro="Psicóloga Clínica · Psicoterapia Psicoanalítica. Más de veinte años acompañando historias singulares."
      />

      <section className="max-w-[1400px] mx-auto px-5 md:px-10 pb-24 md:pb-32">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
          {/* Sticky portrait */}
          <div className="md:col-span-5">
            <div className="md:sticky md:top-28">
              <div className="relative max-w-[420px]">
                <div className="absolute -inset-3 border border-[#9C5A4B]/40 translate-x-4 translate-y-4 pointer-events-none" />
                <div className="relative overflow-hidden aspect-[4/5]">
                  <img
                    src={portrait}
                    alt="Lizy Rodríguez"
                    className="portrait-frame w-full h-full object-cover"
                    data-testid="sobre-mi-portrait"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Text */}
          <div className="md:col-span-6 md:col-start-7">
            <Reveal>
              <h2 className="font-display text-3xl md:text-4xl lg:text-5xl tracking-tight leading-tight mb-8">
                {sobreMi.title}
              </h2>
            </Reveal>
            <div className="space-y-6">
              {sobreMi.intro.map((p, i) => (
                <Reveal key={i} delay={i * 0.05}>
                  <p className="text-lg leading-relaxed text-[#1a1a1a]/85 font-light">
                    {p}
                  </p>
                </Reveal>
              ))}
            </div>

            {/* Experience */}
            <Reveal>
              <h3 className="font-display text-2xl md:text-3xl mt-14 mb-6">
                {sobreMi.experienceTitle}
              </h3>
            </Reveal>
            <div className="flex flex-wrap gap-3">
              {sobreMi.experience.map((e, i) => (
                <Reveal key={e} delay={i * 0.04}>
                  <span className="inline-block border border-black/15 rounded-full px-5 py-2 text-sm text-[#1a1a1a]/80">
                    {e}
                  </span>
                </Reveal>
              ))}
            </div>

            {/* Way of working */}
            <Reveal>
              <h3 className="font-display text-2xl md:text-3xl mt-14 mb-6">
                {sobreMi.workTitle}
              </h3>
            </Reveal>
            <Reveal delay={0.05}>
              <p className="text-lg leading-relaxed text-[#1a1a1a]/85 font-light">
                {sobreMi.work}
              </p>
            </Reveal>
          </div>
        </div>
      </section>

      <BookCTA />
    </div>
  );
}
